import { BundleType } from './builder-config';
import { PackageName } from './package-name';

export interface ScriptSourcePlaceholder {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  PACKAGE_NAME: PackageName;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  BUNDLE_TYPE: BundleType;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  VERSION?: string;
}

// We have to stay backwards compatible with the previous scriptSource's function signature,
// which was scriptSource(isLocal: boolean, placeHolder: ScriptSourcePlaceHolder)
// because otherwise we would break previous loader versions.
export function scriptSource(cdn: boolean | string | undefined, placeholder: ScriptSourcePlaceholder) {
  let pattern: string;

  const defaultCdn = 'https://cdn.player.foundation';
  const cdnPattern = '/{PACKAGE_NAME}/{VERSION}/{BUNDLE_TYPE}';

  if (typeof cdn === 'boolean' && cdn) {
    // Note: This boolean "cdn" case is the deprecated "isLocal" case.

    // use old logic with local pattern
    pattern = '/@foundation-player/{PACKAGE_NAME}/{BUNDLE_TYPE}';
  } else {
    let selectedCdn = (cdn && cdn.trim()) || defaultCdn;
    // Ensure that we won't end up with double slashes, because the pattern contains a leading slash.
    selectedCdn = selectedCdn.endsWith('/') ? selectedCdn.substring(0, selectedCdn.length - 1) : selectedCdn;
    pattern = selectedCdn + cdnPattern;
  }

  let source = pattern;
  const keys = Object.keys(placeholder) as (keyof ScriptSourcePlaceholder)[]; // do not use Object.entries to avoid additional polyfills
  for (const key of keys) {
    const value = placeholder[key] || '';
    source = source.replace(`{${key}}`, value);
  }

  return source;
}
